var levelOfAWSUsage = {
	"Level of AWS usage": "AWS 使用水平",
	"Do not use AWS today": "目前没有使用 AWS",
	"Evaluating/experimenting with AWS": "评估/试用 AWS",
	"Run dev/test workloads on AWS": "在 AWS 上运行开发/测试工作负载",
	"Run a production workload on AWS": "在 AWS 上运行单个生产工作负载",
	"Run multiple production workloads on AWS": "在 AWS 上运行多个生产工作负载"
};

export { levelOfAWSUsage as default };
